<template>
	<div class="party_center">
		<div class="nc_pc" v-if="!isPhone">
			<div class="news_sort" v-if="catelist.length">
				<div class="sort_list flex1">
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>{{catelist[0].title}}</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(4)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item, index) in nlist1" :key="item.id" @click="toDetail(item, 4)">
							<div class="soem_item1 flex3" v-if="index == 0">
								<div class="soem_item1_left">
									<img :src="item.image">
								</div>
								<div class="soem_item1_right">
									<div class="srt_date flex3">
										<img src="@/images/rili_blue.png">
										<span>{{ item.addtime.slice(0, 10) }}</span>
									</div>
									<div class="srt_pt1 ellip2">{{ item.title }}</div>
								</div>
							</div>
							<div v-if="index > 0" class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>{{catelist[1].title}}</span>
								<!-- <span>/&nbsp; GRASSROOTS DYNAMICS</span> -->
							</div>
							<div class="soem_tit_right" @click="toLookMore(5)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item, index) in nlist2" :key="item.id" @click="toDetail(item, 5)">
							<div class="soem_item1 flex3" v-if="index == 0">
								<div class="soem_item1_left">
									<img :src="item.image">
								</div>
								<div class="soem_item1_right">
									<div class="srt_date flex3">
										<img src="@/images/rili_blue.png">
										<span>{{ item.addtime.slice(0, 10) }}</span>
									</div>
									<div class="srt_pt1 ellip2">{{ item.title }}</div>
								</div>
							</div>
							<div v-if="index > 0" class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>{{catelist[2].title}}</span>
								<!-- <span>/&nbsp; SAFE PRODUCTION</span> -->
							</div>
							<div class="soem_tit_right" @click="toLookMore(1)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item, index) in nlist3" :key="item.id" @click="toDetail(item, 1)">
							<div class="soem_item1 flex3" v-if="index == 0">
								<div class="soem_item1_left">
									<img :src="item.image">
								</div>
								<div class="soem_item1_right">
									<div class="srt_date flex3">
										<img src="@/images/rili_blue.png">
										<span>{{ item.addtime.slice(0, 10) }}</span>
									</div>
									<div class="srt_pt1 ellip2">{{ item.title }}</div>
								</div>
							</div>
							<div v-if="index > 0" class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>{{catelist[3].title}}</span>
								<!-- <span>/&nbsp; GROUP NEWSPAPERS AND MAGAZINES</span> -->
							</div>
							<div class="soem_tit_right" @click="toLookMore(6)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item, index) in nlist4" :key="item.id" @click="toDetail(item, 6)">
							<div class="soem_item1 flex3" v-if="index == 0">
								<div class="soem_item1_left">
									<img :src="item.image">
								</div>
								<div class="soem_item1_right">
									<div class="srt_date flex3">
										<img src="@/images/rili_blue.png">
										<span>{{ item.addtime.slice(0, 10) }}</span>
									</div>
									<div class="srt_pt1 ellip2">{{ item.title }}</div>
								</div>
							</div>
							<div v-if="index > 0" class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="nc_ph" v-if="isPhone">
			<Header2 :searchShow="true" pageTitle="新闻中心"></Header2>
			<div class="news_sort">
				<div class="sort_list">
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>{{catelist[0].title}}</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(4)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item) in nlist1" :key="item.id" @click="toDetail(item, 4)">
							<div class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>{{catelist[1].title}}</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(5)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item) in nlist2" :key="item.id" @click="toDetail(item, 5)">
							<div class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>{{catelist[2].title}}</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(1)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item) in nlist3" :key="item.id" @click="toDetail(item, 1)">
							<div class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>{{catelist[3].title}}</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(6)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item) in nlist4" :key="item.id" @click="toDetail(item, 6)">
							<div class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			banner: '',
			nlist1: [],
			nlist2: [],
			nlist3: [],
			nlist4: [],
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
            catelist:[],
		}
	},
	computed: {
		...mapState(["headList"]),
	},
	mounted() {
		this.getTabArr(this.headList);
	},
	watch: {
		headList(newVal, oldVal) {
			if (newVal.length) {
				this.getTabArr(newVal);
			}
		}
	},
	created() {
		this.djcate();
	},
	methods: {
		getTabArr(arr) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i].name == '/partyCenter') {
					this.banner = this.$staticImg + arr[i].image;
				}
			}
		},
		async djcate() {
			const res = await this.$api.djcate();
			if (res.code == 1) {
                this.catelist = res.data.cate;
				this.nlist1 = res.data.son1;
                for (let i = 0; i < this.nlist1.length; i++) {
					if (this.nlist1[i].image.indexOf("http") == -1) {
                        this.nlist1[i].image = this.$staticImg+this.nlist1[i].image;
					}
				}
				this.nlist2 = res.data.son2;
                for (let i = 0; i < this.nlist2.length; i++) {
					if (this.nlist2[i].image.indexOf("http") == -1) {
                        this.nlist2[i].image = this.$staticImg+this.nlist2[i].image;
					}
				}
				this.nlist3 = res.data.son3;
                for (let i = 0; i < this.nlist3.length; i++) {
					if (this.nlist3[i].image.indexOf("http") == -1) {
                        this.nlist3[i].image = this.$staticImg+this.nlist3[i].image;
					}
				}
				this.nlist4 = res.data.son4;
                for (let i = 0; i < this.nlist4.length; i++) {
					if (this.nlist4[i].image.indexOf("http") == -1) {
                        this.nlist4[i].image = this.$staticImg+this.nlist4[i].image;
					}
				}
			}
		},
		toLookMore(a) {
			this.$router.push('/partyBuilding/partyList?sort=' + 1+'&sort2='+a);
		},
		toDetail(item, a) {
			this.$router.push("/partyBuilding/partyDetail?id=" + item.id + '&sort=' + 1 + '&sort2=' + a);
		},
	}
}
</script>

<style lang="scss">
.party_center {
	.nc_pc {
		.news_sort {
			.sort_list {
				width: 100%;
				flex-wrap: wrap;
				align-items: flex-start;

				.sort_item {
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
					margin-bottom: 50px;
					background-color: #fff;
					padding: 30px 25px 40px 25px;
					border-radius: 10px;
					box-sizing: border-box;
					width: 48%;

					.soem_tit {
						padding-bottom: 15px;
						border-bottom: 1px solid #d1d1d1;
						align-items: flex-end;

						.soem_tit_left {
							span {
								&:nth-child(1) {
									padding-bottom: 15px;
									font-size: 26px;
									border-bottom: 1px solid #003f99;
								}

								&:nth-child(2) {
									margin-left: 10px;
									color: #ddd;
								}
							}
						}

						.soem_tit_right {
							color: #ddd;
							cursor: pointer;

							&:hover {
								color: #ff8041;
							}
						}
					}

					.tm_box {
						.soem_item1 {
							margin-top: 23px;
							margin-bottom: 10px;
							align-items: flex-start;

							.soem_item1_left {
								width: 180px;
								height: 120px;
								overflow: hidden;
								border-radius: 10px;

								img {
									width: 180px;
									height: 120px;
									transition: transform 0.5s ease;
									&:hover {
										transform: scale(1.05);
									}
								}
							}

							.soem_item1_right {
								margin-left: 25px;
								padding-top: 10px;
								cursor: pointer;
								flex: 1;

								.srt_date {
									img {
										width: 20px;
									}

									span {
										color: #b8b8b8;
										margin-left: 6px;
										font-size: 16px;
									}
								}

								.srt_pt1 {
									font-size: 17px;
									margin-top: 20px;
									line-height: 1.8;

									&:hover {
										color: #003f99;
									}
								}
							}
						}

						.soem_item2 {
							align-items: flex-end;
							padding: 15px 0;
							border-bottom: 1px dashed #eee;
							cursor: pointer;

							&:hover {
								.stm2_left {
									div {
										color: #003f99;
									}
								}

								.stm2_right {
									color: #333;
								}
							}

							.stm2_left {
								flex: 1;

								.youxia {
									width: 15px;
									font-weight: bold;
									margin-top: 5px;
								}

								div {
									flex: 1;
									width: 0;
									margin-left: 15px;
									font-size: 17px;
									color: #8c8c8c;
								}
							}

							.stm2_right {
								margin-left: 20px;
								font-size: 17px;
								color: #8c8c8c;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1600px) {
		.nc_pc {
			.news_sort {
				.sort_list {
					.sort_item {
						.tm_box {
							.soem_item1 {
								.soem_item1_left {
									width:150px;
									height: 100px;

									img {
										width: 150px;
										height: 100px;
									}
								}

								.soem_item1_right {
									padding-top: 6px;
                                    margin-left: 20px;
									.srt_date {
										span {
											font-size: 15px;
										}
									}

									.srt_pt1 {
										font-size: 16px;
										margin-top: 15px;
									}
								}
							}

							.soem_item2 {
								.stm2_left {
									div {
										font-size: 16px;
									}
								}

								.stm2_right {
									font-size: 16px;
								}
							}
						}
					}
				}
			}
		}
	}

	.nc_ph {
		// padding-top: 0.5rem;
		padding-bottom: 80px;

		.news_sort {
			background-color: #f6f6f6;
			padding: 0.35rem;

			.sort_list {
				width: 100%;

				.sort_item {
					margin-bottom: 0.5rem;
					background-color: #fff;
					padding: 0.4rem;
					border-radius: 0.25rem;
					box-sizing: border-box;

					.soem_tit {
						padding-bottom: 0.35rem;
						border-bottom: 1px solid #d1d1d1;
						align-items: flex-end;

						.soem_tit_left {
							span {
								&:nth-child(1) {
									padding-bottom: 15px;
									font-size: 0.35rem;
									border-bottom: 1px solid #003f99;
								}

								&:nth-child(2) {
									margin-left: 0.25rem;
									color: #ddd;
								}
							}
						}

						.soem_tit_right {
							color: #ddd;
							cursor: pointer;

							&:hover {
								color: #ff8041;
							}
						}
					}

					.tm_box {
						.soem_item2 {
							align-items: flex-end;
							padding: 15px 0;
							border-bottom: 1px dashed #eee;
							cursor: pointer;

							&:hover {
								.stm2_left {
									div {
										color: #003f99;
									}
								}

								.stm2_right {
									color: #333;
								}
							}

							.stm2_left {
								flex: 1;

								.youxia {
									width: 15px;
									font-weight: bold;
									margin-top: 5px;
								}

								div {
									flex: 1;
									width: 0;
									margin-left: 15px;
									font-size: 18px;
									color: #8c8c8c;
								}
							}

							.stm2_right {
								margin-left: 20px;
								font-size: 17px;
								color: #8c8c8c;
							}
						}
					}
				}
			}
		}
	}
}
</style>